import styled from "styled-components";

export const FooterBase = styled.footer``;
